import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Syllabus } from 'src/app/_models/syllabus';
import { TopicService } from 'src/app/_services/topic.service';
import { Topic } from '../../../../_models/topic';
import { SyllabusService } from '../../../../_services/syllabus.service';
declare var $ : any;
@Component({
  selector: 'app-admin-syllabus-topic-edit',
  templateUrl: './admin-syllabus-topic-edit.component.html',
  styleUrls: ['./admin-syllabus-topic-edit.component.css']
})
export class AdminSyllabusTopicEditComponent implements OnInit {
  @Input() syllabus =  new Syllabus()
  @Input() topic:Topic =  undefined
  @Output()  editTopicFinished= new EventEmitter<boolean>()
  loading=false
  errorSaving=false
  isSaving=false
  editTopicForm:FormGroup
  constructor(
    private syllabusService:SyllabusService,
    private topicService:TopicService,
    ) { }
    get f()
    {
      return this.editTopicForm.controls
    }

  ngOnInit(): void {
    if(this.topic){
      this.editTopicForm= new FormGroup ( {
        topicName: new FormControl(this.topic.name, [Validators.required,Validators.minLength(3)])
      })
    }
    this.loading=true
    this.errorSaving=false
  }


  on_submit(){
    this.isSaving=true
    let dd=this.formatData(this.editTopicForm.value.topicName)
    this.topicService.editTopic(dd).subscribe(
      val=>{
        if(val['server_syllabus_id']==0){
          this.errorSaving=true
        }
        else{
          this.syllabus=val
          this.loading=false
          this.editTopicFinished.emit(true)
          this.closeRegModal()

        }
        this.isSaving=false
      }
    )

  }
  formatData(topicName:string){
    let data = new URLSearchParams();
    data.set('name', topicName);
    data.set('id', this.topic.server_topic_id.toString());
    data.set('server_syllabus_id', this.topic.server_syllabus_id.toString());
    return data.toString()
  }
  closeRegModal(){
    $("#editTopicModal").modal("hide");
  }
}
